module.exports = __webpack_public_path__ + "media/images/flags/np-ecc31e52fb6b958eb68131f217009d1b.svg";